import { InstancedBufferAttribute, InstancedBufferGeometry, PlaneGeometry, Vector3 } from 'three';

export default class Geometry extends InstancedBufferGeometry {
    constructor() {
        super();
        const baseGeo = new PlaneGeometry();
        this.setAttribute('position', baseGeo.getAttribute('position'));
        this.setAttribute('normal', baseGeo.getAttribute('normal'));
        this.setAttribute('uv', baseGeo.getAttribute('uv'));
        this.index = baseGeo.index;
    }

    setIdleBuffers(instances: number, particleScale = 1) {
        const offsets: number[] = [];
        const scales: number[] = [];
        const delays: number[] = [];
        const speeds: number[] = [];
        const randoms: number[] = [];
        const indices: number[] = [];

        const vectorScale = new Vector3();

        const randArray = [0, 0, 0, 0, 0, 0, 0, 1];

        for (let i = 0; i < instances; i++) {
            indices.push(i);

            const rand = randArray[Math.floor(Math.random() * randArray.length)];
            randoms.push(rand);

            delays.push(Math.random() * 1);
            speeds.push(1.0 + Math.random());

            const x = (Math.random() * 2 - 1) * 2;
            const y = -0.5 + Math.random() * 2.3;
            const z = (Math.random() * 2 - 1) * 2;

            offsets.push(x, y, z);

            let s = 0.004 + rand * 0.006;

            s *= particleScale;

            vectorScale.set(s, s, s);

            scales.push(vectorScale.x, vectorScale.y, vectorScale.z);
        }

        this.instanceCount = instances;

        this.setAttribute('index', new InstancedBufferAttribute(new Float32Array(indices), 1));
        this.setAttribute('offset', new InstancedBufferAttribute(new Float32Array(offsets), 3));
        this.setAttribute('rand', new InstancedBufferAttribute(new Float32Array(randoms), 1));
        this.setAttribute('delay', new InstancedBufferAttribute(new Float32Array(delays), 1));
        this.setAttribute('speed', new InstancedBufferAttribute(new Float32Array(speeds), 1));
        this.setAttribute('scale', new InstancedBufferAttribute(new Float32Array(scales), 3));
    }
}
